import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import classNames from 'classnames';

import { RangeDatepicker } from 'src/components/RangeDatepicker/RangeDatepicker';
import { AppButton } from 'src/components/AppButton/AppButton';

import './rangeFilter.scss';

interface RangeFilterProps {
  closeRangeFilterHandler: () => void;
  onChangeRangeFilterHandler: ([startRange, endRange]: [Date, Date]) => void;
  onResetRangeFilter: () => void;
  onApplyRangeFilter: () => void;
  startDate: Date | null;
  endDate: Date | null;
}

export const RangeFilter: React.FC<RangeFilterProps> = props => {
  const {
    closeRangeFilterHandler,
    onChangeRangeFilterHandler,
    onResetRangeFilter,
    onApplyRangeFilter,
    startDate,
    endDate,
  } = props;

  useEffect(() => {
    if (isMobile) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'auto';
      };
    }
  }, []);

  useEffect(() => {
    if (!isMobile && startDate && endDate) {
      onApplyRangeFilter();
    }
  }, [startDate, endDate, onApplyRangeFilter]);

  return (
    <div className={classNames('logs-range-filter', { 'is-desktop': !isMobile })}>
      {isMobile && (
        <div className="logs-range-filter__header">
          <button onClick={closeRangeFilterHandler}>Close</button>
        </div>
      )}

      <RangeDatepicker
        onChangeRangeFilterHandler={onChangeRangeFilterHandler}
        startDate={startDate}
        endDate={endDate}
      />

      {isMobile && (
        <div className="logs-range-filter__footer">
          <AppButton
            title="Apply"
            disabled={!(startDate && endDate)}
            onClick={onApplyRangeFilter}
          />
          <AppButton title="Reset" secondary onClick={onResetRangeFilter} />
        </div>
      )}
    </div>
  );
};
